import { Box, Tooltip, Typography } from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import { ReactElement } from 'react';

export const THUMBNAIL_SIZE = 42;
const LARGE_SIZE = 192;

export const ThumbnailFrame = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: THUMBNAIL_SIZE,
  height: THUMBNAIL_SIZE,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.action.hover,
  borderRadius: '6px',
  overflow: 'hidden',
}));

interface PartFinderThumbnailHoverProperties {
  children: ReactElement;
  thumbnailUrl: string;
  alt: string;
  caption: string;
}

export const PartFinderThumbnailHover = ({
  children,
  thumbnailUrl,
  alt,
  caption,
}: PartFinderThumbnailHoverProperties) => {
  const theme = useTheme();
  return (
    <Tooltip
      placement='right'
      followCursor
      disableFocusListener
      disableTouchListener
      slotProps={{
        tooltip: {
          sx: {
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '12px',
            padding: '8px',
            boxShadow: theme.shadows[3],
          },
        },
      }}
      title={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Box
            sx={{
              width: LARGE_SIZE,
              height: LARGE_SIZE,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: theme.palette.action.hover,
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            <img src={thumbnailUrl} alt={alt} width={LARGE_SIZE} height={LARGE_SIZE} style={{ objectFit: 'contain' }} />
          </Box>
          <Typography variant='caption' sx={{ color: theme.palette.text.secondary, textAlign: 'center' }}>
            {caption}
          </Typography>
        </Box>
      }
    >
      {children}
    </Tooltip>
  );
};
